import { combineReducers } from "redux";
import User from "./user/reducer";

const rootReducer = combineReducers({
  User,
});

export default rootReducer;
